// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/@kangc/v-md-editor/lib/style/base-editor.css
// module id = hgI+
// module chunks = 1